import React from 'react';

import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { useTranslate } from '@lumapps/translations';

import { EMPTY_STATES } from '../../constants';

/** Empty state of the ask ai banner */
export const AskAiEmptyState: React.FC = () => {
    const { translateKey } = useTranslate();

    return (
        <EmptyState
            title={translateKey(EMPTY_STATES.noResults.subtitle)}
            message={translateKey(EMPTY_STATES.noResults.description)}
            iconProps={{ icon: EMPTY_STATES.noResults.icon }}
        />
    );
};
